export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";